import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ValueTable.styled';
import TableHeader from '../../atoms/TableHeader/TableHeader';
import TableRow from '../../atoms/TableRow/TableRow';
import Table from '../../atoms/Table/Table';
import TableCell from '../../atoms/TableCell/TableCell';
import { resultItem } from '../../../proptypes/Actions';

const ValueTable = (props) => {
  return (
    <Table>
      <thead>
        <tr>
          <th>Description</th>
          <th>Value</th>
          <th>Normal Range</th>
          <th>Unit</th>
        </tr>
      </thead>
      <tbody>
        {props.resultItem.childItems.map((child) => {
          return (
            <tr key={child.type}>
              <td>{child.title}</td>
              <td>{child.value}</td>
              <td>
                {child.normalValueMin && child.normalValueMax
                  ? `${child.normalValueMin}-${child.normalValueMax}`
                  : ''}
              </td>
              <td>{child.metric}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};

ValueTable.propTypes = {
  resultItem: resultItem,
};

export default ValueTable;
